
<template>
<!-- 素材管理（图片;视频） -->
<div class="material">
    <!-- 左侧 目录区域------------------------------------->
    <div class="material__left">
        <div class="flex-1 min-h-0">
            <!-- 可滚动 -->
            <el-scrollbar wrap-class="scrollbar-wrapper">
                <div>
                    <!-- ref="treeRef"
                        node-key="id" -->
                    <el-tree
                        :data="cateLists"
                        empty-text=""
                        :highlight-current="true"
                        :expand-on-click-node="false"
                        :current-node-key="cateId"
                        @node-click="handleCatSelect">

                        <template v-slot="{ data }">
                            <div class="flex flex-1 pr-4 items-center">
                                <!-- 图标 -->
                                <img class="img-treeview mr-2"
                                src="@/assets/images/icon_folder.png"/>
                                <!-- 名称 -->
                                <span class="flex-1 ml-1 mr-2">
                                    {{data.categoryName}}
                                </span>

                                <!-- 操作 -->
                                <el-dropdown trigger="click"
                                :hide-on-click="false">
                                    <span class="muted m-r-10">···</span>
                                    <template>
                                        <el-dropdown-menu>
                                            <popover-input
                                                v-bind:value="data.categoryName"
                                                @confirm="handleEditCate($event, data.id)"
                                            >
                                                <div>
                                                    <el-dropdown-item>
                                                        命名分组
                                                    </el-dropdown-item>
                                                </div>
                                            </popover-input>

                                            <div @click="handleDeleteCate(data.id)">
                                                <el-dropdown-item>删除分组</el-dropdown-item>
                                            </div>
                                        </el-dropdown-menu>
                                    </template>
                                </el-dropdown>
                                
                            </div>
                            
                        </template>
                    </el-tree>
                </div>
            </el-scrollbar>
        </div>
        <div class="material__left_bottom">
            <popover-input
                value=""
                @confirm="handleAddCate($event)"
            >
                <el-button> 添加分组 </el-button>
            </popover-input>
        </div>
    </div>
    <!-- 中间内容区域 ---------------------------------------->
    <div class="material_center">
        <!-- 顶部操作部分 -->
        <div class="operate-btn">
            <!-- 左侧操作按钮 -->
            <div class="flex flex-1">
                <!-- data 上传的参数 -->
                <tip-upload
                    @change="refresh" 
                    :data="{fileKey:'xcimg',categoryId:cateId}">
                    <el-button type="primary">本地上传</el-button>
                </tip-upload>

                <!-- 删除 -->
                <el-button
                    v-hasPermi="['albums:albumDel']"
                    :disabled="!selectList.length"
                    @click="batchFileDelete()"
                >删除</el-button>

                <!-- 移动 -->
                <pop-up
                    class="ml-3"
                    title="移动文件"
                        v-if="mode == 'page'"
                    @confirm="batchFileMove"
                    :disabled="!selectList.length">
                    <template #trigger>
                        <el-button :disabled="!selectList.length">移动</el-button>
                    </template>

                    <!-- 到默认插槽 -->
                        <div>
                        <span class="mr-5">移动文件至</span>
                        <el-select v-model="moveId" placeholder="请选择">
                            <template v-for="item in cateLists" >
                                <el-option
                                    :key="item.id"
                                    v-if="item.id !== ''"
                                    :label="item.label"
                                    :value="item.id"
                                ></el-option>
                            </template>
                        </el-select>
                    </div>
                </pop-up>
                
            </div>

            <!-- 右侧搜索框 和 切换列表 -->
            <div class="operate-input">
                <!-- 搜索框 -->
                <el-input
                    placeholder="请输入名称"
                    min="10"
                    @keyup.enter="refresh"
                >
            
                    <template #append>
                        <el-button @click="refresh" icon="el-icon-search">
                        </el-button>
                    </template>
                </el-input>
                
            </div>

            <div class="flex items-center">
                <!-- 列表视图按钮 -->
                <el-tooltip content="列表视图" placement="top">
                    <div
                        class="list-icon"
                        :class="{
                            select: listShowType == 'table'
                        }"
                        @click="listShowType = 'table'"
                    >
                        <icon name="local-icon-list" :fontsize="'18px'" />
                        <!-- <i class="el-icon-menu" :size="18" /> -->
                    </div>
                </el-tooltip>
                <!-- 平铺视图按钮 -->
                <el-tooltip content="平铺视图" placement="top">
                    <div
                        class="list-icon"
                        :class="{
                            select: listShowType == 'normal'
                        }"
                        @click="listShowType = 'normal'"
                    >
                        <icon name="el-icon-menu" :fontsize="'18px'" />
                        
                    </div>
                </el-tooltip>
            </div>
            
        </div>
        <!--  -->
        <div class="mt-3" v-if="mode == 'page'">
            <el-checkbox
            :disabled="!filelist.length"
                v-model="isCheckAll"
                @change="selectAll"
                :indeterminate="isIndeterminate" >
                当页全选
            </el-checkbox>
        </div>

        <!-- 数据区域 -->
        <div class="material-center__content">
            <!-- 平铺视图 -->
            <el-scrollbar class="material-scroll" wrap-class="scrollbar-wrapper" v-if="filelist.length>0" v-show="listShowType=='normal'" >
                <ul class="file-list">
                    <li class="file-item-wrap"
                        v-for="item in filelist"
                        :key="item.id"
                        :style="{ width: fileSize }">
                        <!-- 图像（显示右上角删除） -->
                        <del-wrap @close="batchFileDelete([item.id])">
                            <fileitem
                                :uri="item.uri"
                                :file-size="fileSize"
                                @click.native="selectFile(item)"
                            >
                                <!-- 选择的样式 -->
                                <div class="item-selected" v-if="isSelect(item.id)">
                                    <!-- <i :size="36" class="el-icon-check" :style="{color:'#fff'}" /> -->
                                    <icon :size="36" color="#fff" name="el-icon-check"/>
                                </div>

                            </fileitem>
                        </del-wrap>
                        <!-- 文件名 -->
                        <overflow-tooltip class="mt-1" :content="item.name" />
                        <!-- 文件操作，重命名和删除 -->
                        <div class="operation-btns flex items-center">
                                <!-- v-perms="['albums:albumRename']" -->
                            <popover-input
                                @confirm="handleFileRename($event, item.id)"
                                size="default"
                                :value="item.name"
                                width="400px"
                                :limit="50"
                                show-limit
                                teleported
                            >
                            <el-button type="text"> 重命名 </el-button>
                            </popover-input>
                            <el-button type="text"  @click="handlePreview(item.uri)">
                                查看
                            </el-button>
                        </div>

                    </li>
                </ul>
            </el-scrollbar>

            <!-- 列表视图 -->
            <el-table 
                v-if="filelist.length>0"
                class="material-talbe" 
                :data="filelist"
                width="100%"
                height="100%"
             
                v-show="listShowType=='table'"
                @row-click="selectFile">
                
                <el-table-column width="55">
                    <template #default="{ row }">
                        <el-checkbox :value="isSelect(row.id)" @change="selectFile(row)" />
                    </template>
                </el-table-column>
                
                <el-table-column label="名称">
                        <template #default="{ row }">
                        <el-link @click.stop="handlePreview(row.uri)" :underline="false">
                            {{ row.name }}
                        </el-link>
                    </template>
                </el-table-column>
                
                <el-table-column label="图片">
                    <template #default="{ row }">
                        <el-link @click.stop="handlePreview(row.uri)" :underline="false">
                            <fileitem :uri="row.uri" file-size="50px"></fileitem>
                        </el-link>
                    </template>
                </el-table-column>

                <el-table-column prop="createTime" label="上传时间" min-width="100" />
                <el-table-column label="操作" width="150" fixed="right">
                    <template #default="{ row }">
                        <div class="inline-block" v-hasPermi="['albums:albumRename']">
                            <popover-input
                                @confirm="handleFileRename($event, row.id)"
                                size="default"
                                :value="row.name"
                                width="400px"
                                :limit="50"
                                show-limit
                                teleported
                            >
                                <el-button  type="text"> 重命名 </el-button>
                            </popover-input>
                        </div>
                        <div class="inline-block">
                            <el-button type="text"  @click.stop="handlePreview(row.uri)">
                                查看
                            </el-button>
                        </div>
                        <div class="inline-block" v-hasPermi="['albums:albumDel']">
                            <el-button
                                    type="text"
                                @click.stop="batchFileDelete([row.id])"
                            >
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <div class="no-data" v-if="!loading && !filelist.length">
                暂无数据~    
            </div>

            <!-- 图片预览
            v-bind:modelValue.sync="showPreview"  -->
            <preview
                v-model="showPreview"
                v-bind:url="priviewUrl">
            </preview> 
        </div>

        <!-- 分页区域 -->
        <div>
            
            <pagination
                v-show="page.totalRow>0"
                :total="page.totalRow"
                :page.sync="page.pageNumber"
                :limit.sync="page.pageLimit"
                @pagination="getFileList"
                background
                layout="prev, pager, next"/>
        </div>
    </div>

    <!-- 右侧-选中的素材----------------------------------------- -->
    <div class="material__right"  v-if="mode == 'picker'">
        <div class="flex justify-between p-2 flex-wrap">
            <div class="sm flex items-center">
                已选择 {{ selectList.length }}
                <span v-if="limit">/{{ limit }}</span>
            </div>
            <el-button type="text"  @click="clearSelect">清空</el-button>
        </div>
        <div class="flex-1 min-h-0">
            <el-scrollbar wrap-class ="scrollbar-wrapper">
                <ul class="select-lists">
                    <li class="mb-4" v-for="item in selectList" :key="item.id">
                        <div class="select-item">
                            <del-wrap @close="cancelSelete(item.id)">
                                <fileitem
                                    :uri="item.uri"
                                    file-size="100px"
                        
                                ></fileitem>
                            </del-wrap>
                        </div>
                    </li>
                </ul>
            </el-scrollbar>
        </div>
    </div>
</div> 
</template>

<script>

import TipUpload from '@/components/tip-upload'//上传用
import PopoverInput from '@/components/PopoverInput'
import PopUp from '@/components/PopUp'
import Pagination from '@/components/Pagination'//分页组件
import Icon from '@/components/Icon/index.vue' //图标组件
import DelWrap from '@/components/DelWrap' // 带删除的容器
import OverflowTooltip from '@/components/OverflowTooltip'
import fileitem from './fileitem.vue'
import Preview from './preview.vue'

import {fileCateList,fileCateAdd,fileCateEdit,fileCateDelete,
fileList,fileDelete,fileMove,fileRename} from '@/api/system/file'

export default {
    components:{PopoverInput,PopUp,TipUpload,Pagination,fileitem,DelWrap,OverflowTooltip, Preview,Icon},
    props:{
        //文件尺寸大小
        fileSize: {
            type: String,
            default: '100px'
        },
        limit:{ //选择文件限制的数量
            type:Number,
            default:100,
        },
        mode:{ //模式 （选择模式）
            type: String,
            default: 'page'
        },
        //已经选择的文件列表
        selectListValue:{
            type:Array,
            default:function () {
                return []
            }
            //default:[] 为错误写法
        }, 
    },
    data(){
        return{
          
            selectList:this.selectListValue,
            isCheckAll:false,
            isIndeterminate:false,
            showPreview:false, //显示预览
            priviewUrl:'',//预览的地址
            treeProps:{
                label: 'label'
            },
            moveId:1, // 移动分组id
            cateId:0, //分组id
            cateLists:[],

            //文件列表
            filelist:[],
            loading:false,
            page:{    
                totalRow:0,
                pageNumber: 1,
				pageLimit: 10
            },

            listShowType:'normal',// 分为 normal 和table
            // selectList:[],//选择的文件
          
        }
    },
    
    created(){
        this.getCateList();
        this.getFileList();
    },

    methods:{
        // 获取分类
        getCateList(){
            //获取分类列表
            fileCateList()
            .then(res=>{ 
                this.cateLists=res.data;
                this.cateLists.unshift({
                        categoryName: '全部',
                        id: 0,
                },)
            })
            .catch(error=>{
                this.$message.error("获取失败")
            })
        },

        // 分类选择
        handleCatSelect(params){
            this.page.pageNumber=1;
            this.cateId=params.id;
            this.getFileList();
        },

        // 增加分类
        handleAddCate(params){
            var para={"parentId":0,"categoryName": params}
            fileCateAdd(para)
            .then(res=>{
                if(res.success){
                    this.getCateList();
                }
            })
            .catch(error=>{

            })
        },
        //重命名分类
        handleEditCate(params,categoryId){
            var para={"id":categoryId,"categoryName": params}
            fileCateEdit(para)
            .then(res=>{
                if(res.success){
                    this.getCateList();
                }
            })
            .catch(error=>{

            })
        },

        // 删除分组
        handleDeleteCate(para){
            this.$confirm('确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'+ para
                });
                }).catch(() => {
                            
                });
        },

        //刷新
        refresh(){
            this.page.pageNumber=1;
            this.getFileList();    
        },

        // 获取文件列表
        getFileList(){
            var para={"categoryId":this.cateId}
            para=Object.assign(para,this.page);
            fileList(para).then(res=>{
                this.filelist=res.data.list;
                this.page.totalRow=res.data.totalRow;
            })
            .catch(error=>{
                this.$message.error("获取文件错误");
                
            })

        },

        //文件重命名
        handleFileRename(params,id){
            var para={"name":params,"id":id};
            fileRename(para)
            .then(res=>{
                if(res.success){
                    this.getFileList();
                }else{
                    this.$message.error("重命名失败");
                }
            })
            .catch(error=>{

            })
        },
        /**
         * 批量删除
         */
        batchFileDelete(para){
            this.$confirm('确认删除后，本地或云存储文件也将同步删除，如文件已被使用，请谨慎操作！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                type: 'info',
                message: '已取消删除'
                });          
            });
        },
        //选择文件
        selectFile(item){
            
            const index = this.selectList.findIndex((items) => items.id == item.id)
            
            if (index != -1) {
                this.selectList.splice(index, 1)
                return
            }
            if (this.selectList.length == this.limit) {
                if (this.limit == 1) {
                    this.selectList = []
                    this.selectList.push(item)
                    return
                }
                ElMessage.warning('已达到选择上限')
                return
            }
            this.selectList.push(item)
        },
        /**
         * 选择全部
         */
        selectAll(value){
            this.isIndeterminate = false
            if (value) {
                this.selectList =[...this.filelist];
                return
            }
            this.clearSelect()
        },

        // 批量移动文件
        async batchFileMove(){
            // 所选择的文件id数组
            const ids = this.selectList.map((item) => item.id)
           
            // 进行移动
            // await fileMove({ ids, cid: this.moveId })
            this.moveId = 0
            
            this.getFileList()
            this.clearSelect()
        },

        isSelect(id){
            //两个叹号的原因
            return !!this.selectList.find((item) => item.id == id)
        },
        // 清空选择的文件
        clearSelect()  {
            this.selectList = [];
        },
        
        cancelSelete(id){
            this.selectList = this.selectList.filter((item) => item.id != id)
        },
        
        handlePreview(para){
            this.priviewUrl=para;
            this.showPreview=true;
        }
    },
    watch:{
        // 选择的全部文件
        selectList:function(newVal,oldVal){
            if (newVal.length == this.filelist.length && newVal.length !== 0) {
                this.isIndeterminate = false
                this.isCheckAll = true
                return
            }

            if (newVal.length > 0) {
                this.isIndeterminate  = true
            } else {
                this.isCheckAll = false
                this.isIndeterminate = false
            }
        }
    }
    
}
</script>

<style>
     .scrollbar-wrapper{
            overflow-x: hidden !important;
        }

        .el-scrollbar__bar.is-vertical{
            right: 0px;
        }

        .el-scrollbar{
            height: 100%;
        }
</style>
<style lang="scss" scoped>
.min-h-0{
    min-height: 500px;
}
.mt-3{
    margin-top: 12px;
}

.ml-1{
   margin-left: 4px; 
}
.ml-3{
    margin-left: 12px;
}
.mr-2{
   margin-right: 8px; 
}
.mr-5{
    margin-right: 20px;
}
.p-2{
    padding: 8px;
}
.pr-4{
    padding-right: 16px;
}
.flex-1{
    flex: 1 1 0%;
}
//   @apply border-r border-br flex flex-col w-[200px];
 .flex{
    display: flex;
 }
 .items-center{
    align-items: center;
 }
.justify-between {
  justify-content: space-between;
}
 .inline-block{
    display: inline-block; 
    padding: 2px;
 }
       
.material {
    display: flex;
    height: 100%;
    // 左侧
    &__left {
        display: flex;
        flex-direction: column;
        width:200px;
        border-right-width: 1px;
        border-color:#4c4d4f;
        border-right-style:solid;
        :deep(.el-tree-node__content) {
            height: 36px;
        }
        .img-treeview{
            width: 20px;
            height: 16px;
        }
        .material__left_bottom{
            display: flex;
            justify-content: center;
            border-top-width: 1px;
            border-top-style: solid;
            border-color: #4c4d4f;
            padding: 8px;
        }
    }
    // 中间
    &_center {
        flex: 1;
        min-width: 0;
        min-height: 0;
        padding: 16px 16px 0;

        .operate-btn{
            display: flex;
            justify-content:space-between;
            .operate-input{
                display: flex;
                margin-left: 10px;
                margin-right: 10px;
            }
        }
        
        .list-icon {
            border-radius: 3px;
            display: flex;
            padding: 5px;
            cursor: pointer;
            color: rgb(74, 93, 255);
            &.select {
                background-color: #b5b8d4;
                
            }
        }
        .material-center__content{
            padding-top: 20px;
            flex-shrink: 1;
        }
        .material-scroll{
            height: calc(100vh - 480px)!important;
            position: relative;
            overflow: hidden;
        }

        .file-list {
            display: flex;
            flex-wrap: wrap;
            list-style: none; 
            .file-item-wrap {
                margin-right: 16px;
                line-height: 1.3;
                cursor: pointer;
                .item-selected {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                    background-color: rgba(0, 0, 0, 0.5);
                    box-sizing: border-box;
                }
                .operation-btns {
                    height: 28px;
                    visibility: hidden;
                }
                &:hover .operation-btns {
                    visibility: visible;
                }
            }
        }
        .no-data{
            padding: 100px;
            display: flex;
            justify-content:center;
            align-items:center;
            
        }
        
    }
    // 右侧
    &__right {
        display: flex;
        flex-direction: column;
        border-left-style: solid;
        border-left-width: 1px;
        border-color:#4c4d4f;

        width: 130px;
        max-height: 600px;
        .select-lists {
            padding: 10px;

            .select-item {
                width: 100px;
                height: 100px;
            }
        }
        .ls-scrollbar{
            height: 500px;
            overflow-y: auto;
        }
    }
    // .material-talbe{
    //     // background-color: blueviolet;
    // }
}
</style>